import axios from 'axios'
import router from '@/router'
import useAuth from '@/utils/useAuth'

const { auth, removeTokens, getTokens } = useAuth()

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/',
  timeout: 60 * 1000, // 1 минута
})

service.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (error) => {
    const originalRequest = error.config
    // 401 - время жизни токена закончилось, нужно обновить
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      error.response?.data?.code === 'access-denied' &&
      error.config?.url !== '/api/oauth/token'
    ) {
      const { token, refreshToken } = getTokens()
      try {
        originalRequest._retry = true
        await auth({
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        })

        originalRequest.headers['Authorization'] = 'Bearer ' + token

        return service(originalRequest)
      } catch (error) {
        console.error(error)
        removeTokens()
        router.push({ name: 'Auth' })
      }

      return service(originalRequest)
    }

    return Promise.reject(error)
  }
)

export default service
